import React, { useMemo } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import type { BrandSummaryRow } from '../../services/supplierService';
import { faNum, faPercent, faToman, marginOf } from './format';

/** «سود بالقوه بر اساس برند» — from purchase-invoices/summary → byBrand */
const BrandProfitTable: React.FC<{ rows: BrandSummaryRow[] }> = ({ rows }) => {
  const sorted = useMemo(
    () =>
      [...rows]
        .map((r) => ({ ...r, profit: (r.saleToman || 0) - (r.costToman || 0) }))
        .sort((a, b) => b.profit - a.profit),
    [rows],
  );

  if (sorted.length === 0) return null;

  return (
    <Paper variant="outlined" sx={{ mt: 3 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ px: 2, pt: 1.5, pb: 1 }}>
        سود بالقوه بر اساس برند
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>برند</TableCell>
              <TableCell align="center">تعداد محصول</TableCell>
              <TableCell align="center">تعداد اقلام</TableCell>
              <TableCell>بهای تمام‌شده</TableCell>
              <TableCell>فروش بالقوه</TableCell>
              <TableCell>سود بالقوه</TableCell>
              <TableCell align="center">حاشیه</TableCell>
              <TableCell align="center">فاکتور / تأمین‌کننده</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((r) => (
              <TableRow key={r.brand || '—'} hover>
                <TableCell sx={{ fontWeight: 600 }}>{r.brand || 'بدون برند'}</TableCell>
                <TableCell align="center">{faNum(r.productCount)}</TableCell>
                <TableCell align="center">{faNum(r.quantity)}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{faToman(r.costToman)}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{faToman(r.saleToman)}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', color: r.profit >= 0 ? 'success.main' : 'error.main' }}>
                  {faToman(r.profit)}
                </TableCell>
                <TableCell align="center">{faPercent(marginOf(r.costToman, r.saleToman))}</TableCell>
                <TableCell align="center">
                  {faNum(r.invoiceCount)} / {faNum(r.supplierCount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default BrandProfitTable;
